import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { getAnsprechpartnerLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { useAnsprechpartnerList } from 'api/ansprechpartner';
import { MenuPlacement } from 'react-select/src/types';

interface AnsprechpartnerSelectProps {
    label?: string;
    kNr?: number;
    kaNr?: number;
    kaName?: string;
    onChange: (kaNr?: number, kaName?: string) => void;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    disabled?: boolean;
}

export const AnsprechpartnerSelect: React.FC<AnsprechpartnerSelectProps> = ({
    label = 'Ansprechpartner',
    kNr,
    kaNr,
    kaName,
    allowEmpty = false,
    onChange,
    menuPlacement = 'bottom',
    disabled = false,
}) => {
    const ansprechpartnerList = useAnsprechpartnerList(
        {
            kNr,
        },
        kNr !== undefined,
    );

    const options = React.useMemo(() => {
        const o =
            ansprechpartnerList?.data
                ?.filter((a) => !a.archiv)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((a) => ({
                    value: a.nr.toString(),
                    label: `${getAnsprechpartnerLabel(a)} ${a.position ? '(' + a.position + ')' : ''}`,
                })) || [];

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [ansprechpartnerList, allowEmpty]);

    return (
        <div>
            <Label>{label}</Label>
            <Select
                name="ansprechpartner"
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    kaNr
                        ? {
                              value: kaNr.toString(),
                              label: kaName || '',
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(parseInt(option?.value || '', 10), option?.label || '');
                }}
            />
        </div>
    );
};
